<template>
    <div :href="productUrl" class="vertical-product-card">
        <a :href="productUrl" class="product-image">
            <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">
        </a>

        <div class="product-info">
            <a :href="productUrl" class="product-name">
                <h6>{{ product.name }}</h6>
            </a>

            <editable-price :product-id="product.id" :current-price="product.price.amount" @price-updated="onPriceUpdated">
              <div class="product-price">$<span v-html="product.formatted_price"></span></div>
            </editable-price>

            <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length" :productId="product.id" :sku="product.sku" :href="productUrl + '#reviews'"/>
        </div>
    </div>
</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],

        methods: {
            onPriceUpdated(data) {
                this.$set(this.product.price, 'amount', data.price)
                this.$set(this.product.price, 'formatted', data.formatted_price)
                this.$set(this.product.selling_price, 'amount', data.selling_price)
                this.$set(this.product.selling_price, 'formatted', data.selling_price_formatted)
            }
        }
    };
</script>
